import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ContextService } from '@bmng/services/context/context.service';
import { catchError, map, of } from 'rxjs';

/**
 * Loads the (global) context for the error page so the support address is the branded one,
 * even on a fresh load (e.g. a redirect from the old Channel Manager).
 * Never fails: the error page must open even when the context can't be loaded.
 */
export const errorContextResolver: ResolveFn<boolean> =
    (route: ActivatedRouteSnapshot) => {
        const contextService = inject(ContextService);

        if (contextService.context.getValue().context) {
            return of(true);
        }

        return contextService.getContext(route, true).pipe(
            map(() => true),
            catchError(() => of(false)),
        );
    };
